<style>
  .image {
    height: 180px;
    background-color: black;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 25px;
    margin: 10px;
  }

  .remove {
    width: 30px;
    height: 30px;
    font-size: 15px !important;
    margin-right: 12px !important;
    margin-top: 12px !important;
    /*background-color: #ff0000 !important;
  color: black !important;*/
    color: white !important;
    background-color: #ff5f00 !important;
  }

  .add {
    color: #1ed21e !important;
    background-color: rgb(108, 117, 137) !important;
  }

  .add-icon {
    margin-top: -11px !important;
    font-size: 20px !important;
  }

  .close-icon {
    margin-top: -8px !important;
    font-size: 19px !important;
  }

  .hidden {
    display: none;
  }
</style>

<mat-dialog-content>
  <h1 class="row">

    @if(request?.RentalObject)
    {
      @if (request.IsClaim) {
        {{ 'Turbo.OneWayAdmin.ServiceDialog.HeadlineClaim' | translate : 'Claim' }} - {{ request.ClaimId }}
      } @else if (request.IsInsurance) {
        {{ 'Turbo.OneWayAdmin.ServiceDialog.HeadlineInsuranceCase' | translate : 'Insurance case' }} - {{ request.InsuranceId }}
      } @else {
       {{ 'Turbo.OneWayAdmin.ServiceDialog.HeadlineIssue' | translate : 'Issue' }} - {{ request.Id }}
      }
      - <t4-object-link [objectId]="request.RentalObject?.Id" [displayText]="request.RentalObject?.Title"></t4-object-link> <span [ngClass]="{ 'red': !request.RentalObject?.IsEnabled && request.RentalObject?.IsDisabledByAdmin, 'yellow': !request.RentalObject?.IsEnabled && !request.RentalObject?.IsDisabledByAdmin, 'green': request.RentalObject?.IsEnabled }">({{ request.RentalObject?.Alias}}) - {{ request.RentalObject?.Type?.Title }}</span>
    }
    <mat-form-field *ngIf="backoffice" appearance="outline" style="margin-bottom: 8px; margin-top: -11px; position: absolute; transform: scale(0.6); right: 0px; " class="col-3">
      <mat-select [(ngModel)]="request.Owner" (selectionChange)="changeOwner(request.Owner)">
        <mat-option [value]="r" *ngFor="let r of selectOwner">{{r}}</mat-option>
      </mat-select>
    </mat-form-field>
  </h1>

  <div class="container" style="width: 900px;"> 
    <div class="row">
      <div class="col-sm-4" style="padding-left: 0; padding-right: 3px;">
        <h2>{{ 'Turbo.OneWayAdmin.ServiceDialog.lblRequestInfo' | translate : 'Request info'}}</h2>
        <div class="turboContainer" style="height: 150px;"> 
          <div>
            <label>{{ 'Turbo.OneWayAdmin.ServiceDialog.lblId' | translate : 'Request Id'}}:</label>
            <span>{{ request.RequestNo }}<span *ngIf="request.IsInsurance"> ({{ request.InsuranceId }})</span><span *ngIf="request.IsClaim"> ({{ 'Turbo.OneWayAdmin.ServiceDialog.lblClaim' | translate : 'Claim' }}: {{ request.ClaimId }})</span></span>
          </div>
          <div *ngIf="request.RecordNumber">
            <label>{{ 'turbo.core.CreateServiceRequestDialog.txtRecordNumber' | translate : 'Record number'}}:</label>
            <span>{{ request.RecordNumber }}</span>
          </div>
          <div>
            <label>{{ 'Turbo.OneWayAdmin.ServiceDialog.lblStatus' | translate : 'Status'}}:</label>
            <span [ngClass]="{ 'expired': request?.ExpectedResolveDate < today }">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus_' + request.Status | translate }}</span>
          </div>
          <div>
            <label>{{ 'Turbo.OneWayAdmin.ServiceDialog.lblCreated' | translate : 'Created at'}}:</label>
            <span>{{ request.CreatedAt | date : 'yyyy-MM-dd HH:mm' }}</span>
          </div>
          <div *ngIf="request.IncidentDate">
            <label>{{ 'Turbo.OneWayAdmin.ServiceDialog.IncidentDate' | translate : 'Incident date'}}:</label>
            <span>{{ request.IncidentDate | date : 'yyyy-MM-dd HH:mm' }}</span>
          </div>
          <div>
            <label>{{ 'Turbo.OneWayAdmin.ServiceDialog.lblExpectedResolveDate' | translate : 'Expected resolve date'}}:</label>
            <span [ngClass]="{ 'expired': request?.ExpectedResolveDate < today }">{{ request.ExpectedResolveDate | date : 'yyyy-MM-dd' }}</span>
          </div>
          <div>
            <label>{{ 'Turbo.OneWayAdmin.ServiceDialog.lblActualResolveDate' | translate : 'Actual resolve date'}}:</label>
            <span>{{ request.ActualResolveDate | date : 'yyyy-MM-dd' }}</span>
          </div>
        </div>
      </div>
      <div class="col-sm-4" style="padding-left: 3px; padding-right: 3px;">
        <h2>{{ 'Turbo.OneWayAdmin.ServiceDialog.lblCurrentLocation' | translate : 'Current location'}}</h2>
        <div class="turboContainer" style="height: 150px;">
          <div>
            <span><b>{{ request.RentalObject?.RentalLocation?.Name }}</b></span>
          </div>
          <div>
            <span>{{ request.RentalObject?.RentalLocation?.Address }}</span>
            <span>{{ request.RentalObject?.RentalLocation?.ZipCode }} {{ request.RentalObject?.RentalLocation?.City }}</span>
          </div>
          <div>
            <span>{{ request.RentalObject?.RentalLocation?.Phone }}</span>
          </div>
          <div>
            <span><a href="mailto:{{ request.RentalObject?.RentalLocation?.Email }}">{{ request.RentalObject?.RentalLocation?.Email }}</a></span>
          </div>
          <div *ngIf="serviceGuy?.ServiceGuyType">
            <label>{{ 'Turbo.OneWayAdmin.ServiceDialog.SGTypeName' | translate : 'ServiceGuy type'}}:</label>
            <span>{{ serviceGuy?.ServiceGuyType?.Name }}</span>
          </div>
          <div *ngIf="serviceGuy?.ServiceGuyType">
            <label>{{ 'Turbo.OneWayAdmin.ServiceDialog.SGTypeDescription' | translate : 'ServiceGuy description'}}:</label>
            <span>{{ serviceGuy?.ServiceGuyType?.Description }}</span>
          </div>
        </div>
      </div>
      <div class="col-sm-4" style="padding-left: 3px; padding-right: 0;">
        <h2>{{ 'Turbo.OneWayAdmin.ServiceDialog.lblServiceLocation' | translate : 'Service location'}}</h2>
        <div class="turboContainer" style="height: 150px;">
          <div>
            <span *ngIf="!Settings.isInAny(['OneWayAdmin', 'Admin'], true)"><b>{{ selectedServicePartner?.Name }}</b></span>
            <mat-select *ngIf="Settings.isInAny(['OneWayAdmin', 'Admin'], true)" [(ngModel)]="selectedServicePartner">
              <mat-option [value]="r" *ngFor="let r of serviceParterList"><b>{{r.Name}}</b></mat-option>
            </mat-select>
          </div>
          <div>
            <span>{{ selectedServicePartner?.Address }}</span>
          </div>
          <div>
            <span>{{ selectedServicePartner?.ZipCode }} {{ selectedServicePartner?.City }}</span>
          </div>
          <div>
            <span>{{ selectedServicePartner?.Phone }}</span>
          </div>
          <div>
            <span><a href="mailto:{{ selectedServicePartner?.Email }}">{{ selectedServicePartner?.Email }}</a></span>
          </div>
          <div *ngIf="request.RentalObject?.RentalLocation?.ServiceZone && !isLoading">
            <span>Zon: {{ selectedServicePartner?.ServiceZone }} ({{ selectedServicePartner?.Distance| number : '1.1-1' }}km)</span>
          </div>
          <mat-progress-bar *ngIf="isLoading" mode="indeterminate" style="top: 99%; " class="turboContainerLoader"></mat-progress-bar>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 15px;">
      <div class="col-xs-9" style="padding-left: 0">
        <div class="turboContainer">
          <mat-tab-group #tabControl style="height: 302px; overflow: auto;">
            <mat-tab label="{{'Turbo.OneWayAdmin.ServiceDialog.tabInfo' | translate : 'Request information'}}">
              <mat-form-field style="width: 50%;">
                <mat-select placeholder="{{ 'Turbo.OneWayAdmin.ServiceDialog.lblTags' | translate : 'Tags'}}" [formControl]="ctrlTags" multiple [disabled]="request.Status == 50 || request.Status == 100">
                  <mat-option *ngFor="let t of availableTags" [value]="t">{{ t }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field style="width: 50%;" *ngIf="request.IsInsurance">
                <input matInput placeholder="{{ 'Turbo.OneWayAdmin.ServiceDialog.lblDiarieNumber' | translate:'Diarie Number'}}" required [(ngModel)]="request.DiarieNumber">
              </mat-form-field>
              <mat-form-field style="width: 100%">
                <textarea matInput placeholder="{{'Turbo.OneWayAdmin.ServiceDialog.txtDescription' | translate : 'Error description'}}" required [(ngModel)]="request.Description" matTextareaAutosize matAutosizeMinRows="9" matAutosizeMaxRows="9" [disabled]="request.Status == 50 || request.Status == 100"></textarea>
              </mat-form-field>
            </mat-tab>
            <mat-tab label="{{'Turbo.OneWayAdmin.ServiceDialog.tabHistory' | translate : 'Change history'}}">
              <div *ngFor="let item of request.Events" class="row">
                <div class="col-xs-3" style="overflow: hidden; text-overflow: ellipsis;">
                  {{ item.CreatedAt | date : 'yyyy-MM-dd HH:mm' }}<br />
                  {{ item.Createdby }}<br />
                  {{ 'Turbo.OneWayAdmin.Service.ServiceStatus_' + item.Status | translate }}<br />
                </div>
                <div class="col-xs-9" [innerHtml]="item.Note"></div>
                <hr class="col-xs-12" />
              </div>
            </mat-tab>
            <mat-tab label="{{ 'Turbo.OneWayAdmin.ServiceDialog.lblUsedParts' | translate : 'Used parts'}}" #tabUsedParts *ngIf="request.RequestNo && !request.IsClaim">
              <t4-used-parts id="{{request.RequestNo}}" type="request" trailer="{{request.RentalObject?.Title}}"></t4-used-parts>
            </mat-tab>
            <mat-tab label="{{ 'Turbo.OneWayAdmin.ServiceDialog.lblServiceDocument' | translate : 'Service document'}}" #tabServiceDocument *ngIf="request.RequestNo && request.ServiceDocument && !request.IsClaim">
              <div style="margin: 5px; display: flex; justify-content: space-between; align-items: center;">
                <a [href]="documentUri" style="margin-right: auto;" target="_blank">{{ 'Turbo.OneWayAdmin.ServiceDialog.msgShowDocument' | translate : 'Click here to show the service document'}}</a>
                <button mat-flat-button color="primary" (click)="regenerateServiceDocument()">
                  {{ 'Turbo.OneWayAdmin.ServiceDialog.cmdRegenerateDocument' | translate : 'Regenerate document'}}
                </button>
              </div>
              <t4-container [isLoading]="isDocumentLoading" style="text-align: center;">
                <object [data]="documentUri" style="width: 100%; height: 38vh;">
                  <a [href]="documentUri" target="_blank">{{ 'Turbo.OneWayAdmin.ServiceDialog.msgShowDocument' | translate : 'Click here to show the service document'}}</a>
                </object>
              </t4-container>
            </mat-tab>
            <mat-tab *ngIf="files" label="{{'Turbo.OneWayAdmin.ServiceDialog.tabAttachedFiles' | translate : 'Attached files'}}">
              <div class="row">
                <div *ngFor="let file of files" class="image col-5" style="cursor: pointer" [ngStyle]="{'background-image': (file.Filename.toLowerCase().endsWith('jpg') || file.Filename.toLowerCase().endsWith('jpeg') || file.Filename.toLowerCase().endsWith('png')) ? 'url(' + file.Uri + ')' : 'transparent' }" (click)="openFile(file)">
                  <div style="position: absolute; margin-top: calc(32% - 10px); width: 90%; height: 20px; color: white; text-align: center; background-color: rgba(0, 0, 0, 0.2)">{{file.Filename}}</div>
                  <button *ngIf="!(file.Filename.toLowerCase().endsWith('jpg') || file.Filename.toLowerCase().endsWith('jpeg') || file.Filename.toLowerCase().endsWith('png'))" mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" class="remove"><mat-icon class="close-icon">download</mat-icon></button>
                  <button *ngIf="file.Filename.toLowerCase().endsWith('jpg') || file.Filename.toLowerCase().endsWith('jpeg') || file.Filename.toLowerCase().endsWith('png')" mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" class="remove"><mat-icon class="close-icon">search</mat-icon></button>
                </div>
                <div class="col-12" *ngIf="!files || files.length == 0">
                  {{'Turbo.OneWayAdmin.ServiceDialog.NoFiles' | translate : 'There are no attached files.'}}
                </div>
                <hr class="col-xs-12" />
              </div>
            </mat-tab>
            <mat-tab *ngIf="!request.IsClaim" label="{{'Turbo.OneWayAdmin.ServiceDialog.tabContactPerson' | translate : 'Contact person'}}">
              <div *ngIf="true || request && request.ContactFirstName" class="row">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.txtFirstname' | translate : 'Firstname'}}</div>
                <div class="col-xs-6">{{ request.ContactFirstName }}</div>
                <hr class="col-xs-12" />
              </div>

              <div *ngIf="true || request && request.ContactLastName" class="row">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.txtLastname' | translate : 'Lastname'}}</div>
                <div class="col-xs-6">{{ request.ContactLastName }}</div>
                <hr class="col-xs-12" />
              </div>

              <div *ngIf="true || request && request.ContactEmail" class="row">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.txtEmail' | translate : 'Email'}}</div>
                <div class="col-xs-6">{{ request.ContactEmail }}</div>
                <hr class="col-xs-12" />
              </div>

              <div *ngIf="true || request && request.ContactPhone" class="row">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.txtCellular' | translate : 'Mobile phone'}}</div>
                <div class="col-xs-6">{{ request.ContactPhone }}</div>
                <hr class="col-xs-12" />
              </div>

              <div class="row">
                <div class="col-12">
                  <button style="width: 100px; height: 40px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-raised-button color="primary" (click)="openContactInfo()">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.Edit' | translate : 'Edit' }}</button>
                </div>
              </div>
            </mat-tab>

            <mat-tab *ngIf="request && !request.IsClaim && Settings.may(Rights.TO_Insurance_Manage)" label="{{'Turbo.OneWayAdmin.ServiceDialog.tabMonetary2' | translate : 'Monetary amounts'}}">
              <h2>{{ 'turbo.core.RentalDialog.lblValues' | translate : 'Values'}}</h2>
              <div class="row">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.lblResidualValue' | translate : 'ResidualValue'}}</div>
                <div class="col-xs-6">{{ request.ResidualValue| currency }}</div>
                <hr class="col-xs-12" />
              </div>
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.lblInsuranceValue' | translate : 'Insurance value'}}</div>
                <div class="col-xs-6">{{ request.InsuranceValue| currency }}</div>
              </div>
              <h2>{{ 'turbo.core.RentalDialog.lblCosts' | translate : 'Costs'}}</h2>
              <div class="row">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.lblRepairs' | translate : 'Repair'}}</div>
                <div class="col-xs-6">{{ request.LaborCost| currency }}</div>
                <hr class="col-xs-12" />
              </div>
              <div class="row">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.lblSpareParts' | translate : 'Spare parts'}}</div>
                <div class="col-xs-6">{{ request.SparePartsCost| currency }}</div>
                <hr class="col-xs-12" />
              </div>
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.lblTransport' | translate : 'Transport'}}</div>
                <div class="col-xs-6">{{ request.TransportCost| currency }}</div>
                <hr class="col-xs-12" />
              </div>
              <h2>{{ 'turbo.core.RentalDialog.lblIncome' | translate : 'Income'}}</h2>
              <div class="row">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.lblSalesPrice' | translate : 'Sales price'}}</div>
                <div class="col-xs-6">{{ request.SalesPrice | currency  }}</div>
                <hr class="col-xs-12" />
              </div>
              <div class="row">
                <div class="col-xs-6">{{ 'turbo.core.RentalDialog.lblSelfRisk' | translate : 'Selfrisk'}}</div>
                <div class="col-xs-6">{{ request.SelfRisk| currency }}</div>
              </div>
            </mat-tab>

          </mat-tab-group>
        </div>
      </div>
      <div class="col-xs-3" *ngIf="!request.IsClaim || backoffice">
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-flat-button color="primary"
                (click)="update(-1)">
          {{'Turbo.OneWayAdmin.ServiceDialog.Actions.cmdSave' | translate : 'Save' }}
        </button>
        @if (request.IsClaim) {
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="setClaimStatus(15)" [disabled]="request.Status >= 50">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valWaitingForDecision' | translate : 'Waiting for decision' }}</button>
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="setClaimStatus(40)" [disabled]="request.Status >= 50">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valWaitingForSpareParts' | translate : 'Waiting for spare parts' }}</button>
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="setClaimStatus(30)" [disabled]="request.Status >= 50">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valWaitingForService' | translate : 'Waiting for service' }}</button>
        } @else {
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="update(30)" *ngIf="selectedServicePartner && request.Status < 50 && (Settings.clientSettings.CanOrderService || Settings.isInAny(['OneWayAdmin'], true))">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valOrderService' | translate : 'Order service' }}</button>
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="update(35)" *ngIf="request.IsInsurance && isStolen && request.Status < 50 && request.Status != 35 && Settings.isInAny(['OneWayAdmin'], true)">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valReportStolen' | translate : 'Report as stolen' }}</button>
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="update(40)" *ngIf="request.Status < 50 && request.Status != 45 && Settings.isInAny(['OneWayAdmin'], true)">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valSpareParts' | translate : 'Order spare parts (Manually)' }}</button>
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="registerInsurance()" *ngIf="!request.IsInsurance && !request.IsClaim && request.Status < 50 && request.Status != 45">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valRegisterInsuranceCase' | translate : 'Register insurance case' }}</button>
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="convertToClaim()" *ngIf="backoffice && !request.IsInsurance && !request.IsClaim">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valConvertToClaim' | translate : 'Convert to claim' }}</button>
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="revertClaim()" *ngIf="backoffice && request.IsClaim">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valRevertClaim' | translate : 'Revert to regular case' }}</button>
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" (click)="requestMoreInformation()" *ngIf="request.Status < 50 && request.Status != 45 && Settings.isInAny(['OneWayAdmin'], true)">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valRequestMoreInformation' | translate : 'Request more information' }}</button>
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-stroked-button color="primary" [matMenuTriggerFor]="attachFiles" *ngIf="(request.Status < 50 && request.Status != 45) || Settings.isInAny(['OneWayAdmin'], true)">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valAttachFiles' | translate : 'Attach images/files' }}</button>
        }
        <button style="width: 100%; height: 50px; margin: 5px 0; white-space: normal; padding: 2px; line-height: 1.5;" mat-raised-button color="primary" (click)="update(50)" *ngIf="!request.IsInsurance || (request.IsInsurance && Settings.isInAny(['OneWayAdmin'], true) && (request.Status < 50 && request.Status != 45))">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.cmdClose' | translate : 'Close issue' }}</button>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!request.IsClaim || backoffice">
  <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation();">
    <mat-icon>more_vert</mat-icon>
  </button>
</mat-dialog-actions>

<mat-menu #menu="matMenu">
  <ng-template matMenuContent>

    @if (request.IsClaim) {
    <button mat-menu-item (click)="emailLocation()" [disabled]="!request.RentalObject?.RentalLocation?.Email">
      <mat-icon matTooltip="{{ 'Turbo.ServiceDialog.Actions.valSendToStation' | translate : 'Send to Station' }}">home</mat-icon>
      <span>{{ 'Turbo.ServiceDialog.Actions.valSendToStation' | translate : 'Send to Station' }}</span>
    </button>
    <button mat-menu-item (click)="emailServiceLocation()" [disabled]="!servicePartner.Email">
      <mat-icon matTooltip="{{ 'Turbo.ServiceDialog.Actions.valSendToServiceLocation' | translate : 'Send to Service Location' }}">build</mat-icon>
      <span>{{ 'Turbo.ServiceDialog.Actions.valSendToServiceLocation' | translate : 'Send to Service Location' }}</span>
    </button>
    <button mat-menu-item (click)="update(100)" [disabled]="request.Status > 49">
      <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valCancel' | translate : 'Cancel' }}">cancel</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valCancel' | translate : 'Cancel' }}</span>
    </button>
    <button mat-menu-item (click)="update(20)" [disabled]="request.Status > 49">
      <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valPark' | translate : 'Park' }}">local_parking</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valPark' | translate : 'Park' }}</span>
    </button>
    } @else {
    <button mat-menu-item [matMenuTriggerFor]="insurance" *ngIf="Settings.isInAny(['OneWayAdmin'], true) && request.IsInsurance">
      <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valInsurance' | translate : 'Insurance' }}">assignment</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valInsurance' | translate : 'Insurance' }}</span>
    </button>

    <button mat-menu-item [matMenuTriggerFor]="logistics" *ngIf="Settings.isInAny(['OneWayAdmin'], true)">
      <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valLogistics' | translate : 'Logistics' }}">local_shipping</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valLogistics' | translate : 'Logistics' }}</span>
    </button>

    <button mat-menu-item (click)="update(20)" [disabled]="request.Status == 45 || (request.Status > 49) || (request.IsInsurance && !Settings.isInAny(['OneWayAdmin'], true))">
      <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valPark' | translate : 'Park' }}">local_parking</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valPark' | translate : 'Park' }}</span>
    </button>

    <button mat-menu-item [matMenuTriggerFor]="messaging" *ngIf="Settings.isInAny(['OneWayAdmin'], true)">
      <mat-icon matTooltip="{{'Turbo.ServiceDialog.Actions.valmMssaging' | translate : 'Messaging' }}">email</mat-icon>
      <span>{{'Turbo.ServiceDialog.Actions.valmMssaging' | translate : 'Messaging' }}</span>
    </button>


    <button mat-menu-item (click)="update(21)" [disabled]="!serviceGuy && request.Status == 45 || (request.Status > 49) || (request.IsInsurance && !Settings.isInAny(['OneWayAdmin'], true))">
      <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valWaitForServiceGuy' | translate : 'Wait for service guy' }}">person</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valWaitForServiceGuy' | translate : 'Wait for service guy' }}</span>
    </button>

    <button mat-menu-item (click)="update(45)" [disabled]="request.Status == 45 || (request.Status > 49)" *ngIf="Settings.isInAny(['OneWayAdmin'], true) && request.IsOneWay">
      <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valExpires' | translate : 'Mark as expired' }}">thumb_down_alt</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valExpires' | translate : 'Mark as expired' }}</span>
    </button>

    <button *ngIf="request.RentalObject?.IsEnabled" mat-menu-item (click)="disable()" [disabled]="request.Status == 45 || (request.Status > 49) || (request.IsInsurance && !Settings.isInAny(['OneWayAdmin'], true))">
      <mat-icon style="color:red" matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valdisable2' | translate : 'Disable' }}">toggle_on</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valDisable' | translate : 'Disable' }}</span>
    </button>

    <button *ngIf="!request.RentalObject?.IsEnabled" mat-menu-item (click)="enable()" [disabled]="request.Status == 45 || (request.Status > 49) || (request.IsInsurance && !Settings.isInAny(['OneWayAdmin'], true))">
      <mat-icon style="color:green" matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valActivate' | translate : 'Activate' }}">toggle_off</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valEnable' | translate : 'Enable' }}</span>
    </button>

    @if(this.request.Tags?.includes("Saknas")){
    <button mat-menu-item [disabled]="!Settings.isInAny(['OneWayAdmin'], true)" (click)="openPoliceText()">
      <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valPolice' | translate : 'Police Templates' }}">local_police</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valPolice' | translate : 'Police Templates' }}</span>
    </button>
    }

    <button mat-menu-item (click)="update(100)" [disabled]="request.Status == 45 || (request.Status > 49) || (request.IsInsurance && !Settings.isInAny(['OneWayAdmin'], true))">
      <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valCancel' | translate : 'Cancel' }}">cancel</mat-icon>
      <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valCancel' | translate : 'Cancel' }}</span>
    </button>
    }




  </ng-template>
</mat-menu>

<mat-menu #insurance="matMenu">
  <button mat-menu-item (click)="invoice()">
    <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valInvoiceSelfrisk' | translate : 'Invoice selfrisk' }}">euro</mat-icon>
    <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valInvoiceSelfrisk' | translate : 'Invoice selfrisk' }}</span>
  </button>
  <button mat-menu-item (click)="terminate()" *ngIf="request.IsInsurance">
    <mat-icon matTooltip="{{ 'Turbo.OneWayAdmin.ServiceDialog.Actions.TerminateTrailer' | translate : 'Terminate trailer' }}">cancel</mat-icon>
    <span>{{ 'Turbo.OneWayAdmin.ServiceDialog.Actions.TerminateTrailer' | translate : 'Terminate trailer' }}</span>
  </button>
  <button mat-menu-item (click)="addCosts()">
    <mat-icon matTooltip="{{ 'Turbo.OneWayAdmin.ServiceDialog.Actions.AddCosts' | translate : 'Add costs' }}">request_quote</mat-icon>
    <span>{{ 'Turbo.OneWayAdmin.ServiceDialog.Actions.AddCosts' | translate : 'Add costs' }}</span>
  </button>
  <button mat-menu-item (click)="repurchase()">
    <mat-icon matTooltip="{{ 'Turbo.OneWayAdmin.ServiceDialog.Actions.Repurchased' | translate : 'Repurchased' }}">repeat</mat-icon>
    <span>{{ 'Turbo.OneWayAdmin.ServiceDialog.Actions.Repurchased' | translate : 'Repurchased' }}</span>
  </button>
</mat-menu>

<mat-menu #logistics="matMenu">
  <button mat-menu-item (click)="update(49)" [disabled]="request.Status == 45 || (request.Status > 49)">
    <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valReturn' | translate : 'Return transport (Manually)' }}">local_shipping</mat-icon>
    <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valReturn' | translate : 'Return transport (Manually)' }}</span>
  </button>
  <button mat-menu-item (click)="update(25)" [disabled]="request.Status == 45 || (request.Status > 49)">
    <mat-icon matTooltip="{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valOrderTransport' | translate : 'Order transport (Manually)' }}">local_shipping</mat-icon>
    <span>{{'Turbo.OneWayAdmin.ServiceDialog.Actions.valOrderTransport' | translate : 'Order transport (Manually)' }}</span>
  </button>
</mat-menu>

<mat-menu #attachFiles="matMenu">
  <button mat-menu-item (click)="uploadImages()">
    <mat-icon matTooltip="{{ 'Turbo.Service.CreateServiceRequestDialog.AddImages' | translate : 'Add images' }}">image</mat-icon>
    <span>{{ 'Turbo.Service.CreateServiceRequestDialog.AddImages' | translate : 'Add images' }}</span>
  </button>
  <button mat-menu-item (click)="uploadFiles()">
    <mat-icon matTooltip="{{ 'Turbo.Service.CreateServiceRequestDialog.AddDamageReport' | translate : 'Add damage report' }}">file_present</mat-icon>
    <span>{{ 'Turbo.Service.CreateServiceRequestDialog.AddDamageReport' | translate : 'Add damage report' }}</span>
  </button>
</mat-menu>


<mat-menu #messaging="matMenu">
  <button mat-menu-item (click)="sendMailDialog()" [disabled]="!serviceGuy">
    <mat-icon matTooltip="{{ 'Turbo.ServiceDialog.Actions.valSendToServiceGuy' | translate : 'Send to Service guy' }}">person_apron</mat-icon>
    <span>{{ 'Turbo.ServiceDialog.Actions.valEmailServiceGuy' | translate : 'Email Service guy' }}</span>
  </button>

  <button mat-menu-item (click)="emailLocation()" [disabled]="!request.RentalObject?.RentalLocation?.Email">
    <mat-icon matTooltip="{{ 'Turbo.ServiceDialog.Actions.valSendToStation' | translate : 'Send to Station' }}">home</mat-icon>
    <span>{{ 'Turbo.ServiceDialog.Actions.valSendToStation' | translate : 'Send to Station' }}</span>
  </button>

  <button mat-menu-item (click)="emailServiceLocation()" [disabled]="!servicePartner.Email">
    <mat-icon matTooltip="{{ 'Turbo.ServiceDialog.Actions.valSendToServiceLocation' | translate : 'Send to Service Location' }}">build</mat-icon>
    <span>{{ 'Turbo.ServiceDialog.Actions.valSendToServiceLocation' | translate : 'Send to Service Location' }}</span>
  </button>

</mat-menu>

